export const RECOVERY_TICK_MS = 500;

export const RECOVERY_ACTIONS = {
  // Reports a fatal playback error, the only action not run on the engine itself
  FAIL: 'fail',
  NUDGE: 'nudge',
  PLAY: 'play',
  BACK_TO_LIVE: 'backToLive',
  RESTART: 'restart',
};

const { FAIL, NUDGE, PLAY, BACK_TO_LIVE, RESTART } = RECOVERY_ACTIONS;

// NOTE: policies hold steps by stream kind and by phase (startup before the first progress, stall after, seek while
// a seek of a started playback did not progress yet), each run after `at` ms without progress

// HTML5 playbacks (ads, jingles, podcasts) not progressing for 8s are reported as failed
export const HEARTBEAT_RECOVERY = {
  vod: {
    startup: [{ at: 8000, actions: [FAIL] }],
    stall: [{ at: 8000, actions: [FAIL] }],
  },
};

// Magenta ads: a frozen picture is nudged and played again before being reported as failed
export const FREEZE_RECOVERY = {
  vod: {
    startup: HEARTBEAT_RECOVERY.vod.startup,
    stall: [{ at: 1000, actions: [NUDGE] }, { at: 2000, actions: [PLAY] }, ...HEARTBEAT_RECOVERY.vod.stall],
  },
};

// Shaka default: a VOD frozen while playing, or stuck in a seek, is restarted; a buffering one is left to Shaka retries
export const FROZEN_RECOVERY = {
  ignoreBuffering: true,
  vod: {
    stall: [{ at: 5000, actions: [RESTART] }],
    seek: [{ at: 10000, actions: [RESTART] }],
  },
};

// Content on Sky and Magenta: a stalled VOD is restarted, a live not starting is pushed to its edge, then restarted
export const RESTART_RECOVERY = {
  // Engine level: a live buffering at start is pushed to its edge
  goToLiveOnStartup: true,
  vod: {
    stall: [{ at: 5000, actions: [RESTART] }],
  },
  live: {
    startup: [
      { at: 5000, actions: [PLAY, BACK_TO_LIVE] },
      { at: 15000, actions: [RESTART] },
    ],
  },
};

// Radio: a stream not starting is pushed to its edge, then restarted
export const RADIO_RECOVERY = {
  live: {
    startup: [
      { at: 1667, actions: [PLAY, BACK_TO_LIVE] },
      { at: 5000, actions: [RESTART] },
    ],
  },
};
